module.exports = __webpack_public_path__ + "img/Deathknight-human-m-70.8ad4eb95.gif";